"use client";

import Link from "next/link";
import { neueHeitz } from "../global-fonts";
import { useState } from "react";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  function handleMenuToggle(isOpen: boolean): void {
    setIsOpen(!isOpen);
  }
  return (
    <header
      className={`flex 
        items-center 
        justify-between 
        pt-4 
        pb-4 
        font-[family-name:var(--font-alegreya-sans)] 
        font-black 
        text-xl 
        sticky 
        sticky-top 
        top-0
        bg-[url(/images/burgundy-textured-background.png)] 
        tracking-widest 
        flex-wrap 
        content-center
        text-sand
        z-1000`}
    >
      <Link
        href="/"
        className={`${neueHeitz.className} 
        hidden 
        lg:block 
        lg:ml-24 
        flex-none 
        lg:text-fluid-base
        `}
      >
        REVOLUTIONARY GRAINS
      </Link>
      <Link
        href="/"
        className={`${neueHeitz.className} 
          text-fluid-xl 
          lg:hidden 
          pl-12
          rg-link`}
      >
        RG
      </Link>
      <button
        className={`lg:hidden 
          bg-[url(/images/mobile-nav-menu.png)] 
          z-1001 
          w-12 
          h-12 
          aspect-square 
          no-repeat 
          bg-contain 
          mr-16`}
        onClick={() => handleMenuToggle(isOpen)}
      >
        <span className="sr-only">Open Menu</span>
      </button>
      {/* Mobile Navigation Menu */}
      <div
        data-is-open={isOpen ? "true" : "false"}
        className={`fixed 
          inset-y-0 
          inset-x-1/3 
          right-0 
          lg:hidden 
          pt-4 
          bg-[url(/images/burgundy-textured-background.png)] 
          lg:hidden 
          motion-safe:transition 
          transition-transform 
          data-[is-open=false]:translate-x-full 
          z-1000`}
      >
        <ul className={`pl-16 pt-32`}>
          <li>
            <Link href="/#projects" onClick={() => handleMenuToggle(isOpen)}>
              PROJECTS
            </Link>
          </li>
          <li>
            <Link href="/our-roots" onClick={() => handleMenuToggle(isOpen)}>
              OUR ROOTS
            </Link>
          </li>
          <li>
            <Link href="/join-us" onClick={() => handleMenuToggle(isOpen)}>
              JOIN US
            </Link>
          </li>
        </ul>
      </div>

      <ul className="hidden lg:flex place-content-evenly w-1/3 mr-8">
        <li>
          <Link href="/#projects" className={`rg-link`}>
            PROJECTS
          </Link>
        </li>
        <li>
          <Link href="/our-roots" className={`rg-link`}>
            OUR ROOTS
          </Link>
        </li>
        <li>
          <Link href="/join-us" className={`rg-link`}>
            JOIN US
          </Link>
        </li>
      </ul>
    </header>
  );
}
